import AnimationClip from '../AnimationClip';
import GameObject from '../../../GameObject/GameObject';
import PIXIRenderer from '../../Render/PIXIRenderer';
import { Easing } from '@tweenjs/tween.js';
import { MathHelper } from '../../../Utility/MathHelper';

export interface MapScrollParams {
    position: {
        x: number;
        y: number;
    };
    maxTime?: number;
}

export class MapScroll extends AnimationClip<MapScrollParams> {
    public *execute(
        gameObject: GameObject,
        meta: MapScrollParams
    ): IterableIterator<number> {
        const { position, maxTime = 2000 } = meta;
        const worldSize: number = PIXIRenderer.mapViewport.width;
        const distance: number = Math.abs(
            PIXIRenderer.mapViewport.position.x - position.x
        );

        const duration: number = MathHelper.lerp(
            0,
            maxTime,
            // Get away from 0 ASAP
            Easing.Exponential.Out(distance / worldSize)
        );

        const scrollTween = this.getTween(
            PIXIRenderer.mapViewport.position
        ).easing(Easing.Cubic.InOut);

        scrollTween.to({ x: position.x }, duration);

        yield* this.startTween(scrollTween);
    }
}
